export const gUiWidgetDimensions = Object.freeze({
  gridHeight     : 5,
  gridWidth      : 8,
  gridCellWidth  : 76,
  gridCellHeight : 76,
  cellGutter     : 12,
});
